'use client';


import UserIcon_default from "../../icons/UserIcon.js";
import { Flex } from "../Layout/Flex/Flex.js";
import { Tooltip } from "../Tooltip/Tooltip.js";
import { chakra, useMultiStyleConfig } from "@chakra-ui/react";
import { c } from "react-compiler-runtime";
import { cloneElement, useMemo } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
import { getInitials } from "@adamdotai/core/utils";
import { getValidChildren } from "@chakra-ui/react-utils";
import * as RadixAvatar from "@radix-ui/react-avatar";
import Image$1 from "next/image";

//#region src/components/Avatar/Avatar.tsx
const ChakraRadixAvatarRoot = chakra(RadixAvatar.Root);
const ChakraNextImage = chakra(Image$1, { shouldForwardProp: (prop) => [
	"src",
	"alt",
	"width",
	"height",
	"fill"
].includes(prop) });
const Avatar = ({ src, name = "", fallback = /* @__PURE__ */ jsx(UserIcon_default, {}), size, borderColor, children, ref, cursor = "unset", __marginEnd = 0, __outline = "none",...props }) => {
	const styles = useMultiStyleConfig("Avatar", { size });
	const nameInitials = useMemo(() => name ? getInitials(name) : "", [name]);
	return /* @__PURE__ */ jsxs(ChakraRadixAvatarRoot, {
		...props,
		__css: styles.root,
		borderWidth: borderColor ? "2px" : void 0,
		borderColor,
		ref,
		marginEnd: __marginEnd,
		outline: __outline,
		cursor,
		children: [
			src && /* @__PURE__ */ jsx(RadixAvatar.Image, {
				asChild: true,
				src,
				children: /* @__PURE__ */ jsx(ChakraNextImage, {
					src,
					alt: name,
					__css: styles.image,
					fill: true
				})
			}),
			/* @__PURE__ */ jsx(RadixAvatar.Fallback, { children: nameInitials || fallback }),
			children
		]
	}, src);
};
const AvatarBadge = (t0) => {
	const $ = c(5);
	const { label, icon } = t0;
	let t1;
	if ($[0] !== icon) {
		t1 = /* @__PURE__ */ jsx(chakra.span, {
			position: "absolute",
			bottom: -2,
			right: -2,
			padding: "2px",
			background: "white",
			borderRadius: "full",
			display: "flex",
			children: icon
		});
		$[0] = icon;
		$[1] = t1;
	} else t1 = $[1];
	let t2;
	if ($[2] !== label || $[3] !== t1) {
		t2 = /* @__PURE__ */ jsx(Tooltip, {
			label,
			placement: "end-start",
			shouldWrapChildren: false,
			children: t1
		});
		$[2] = label;
		$[3] = t1;
		$[4] = t2;
	} else t2 = $[4];
	return t2;
};
const AvatarGroup = (t0) => {
	const $ = c(11);
	const { isStacked: t1, size: t2, spacing: t3, children } = t0;
	const isStacked = t1 === void 0 ? false : t1;
	const size = t2 === void 0 ? "md" : t2;
	const spacing = t3 === void 0 ? 2 : t3;
	let t4;
	if ($[0] !== children || $[1] !== isStacked || $[2] !== size || $[3] !== spacing) {
		const validChildren = getValidChildren(children);
		let t5$1;
		if ($[5] !== isStacked || $[6] !== size || $[7] !== spacing) {
			t5$1 = (child, idx) => {
				const isLastElementRendered = idx === 0;
				return cloneElement(child, {
					size,
					__marginEnd: isLastElementRendered ? 0 : isStacked ? -1 : spacing,
					__outline: isStacked ? "3px solid white" : "none"
				});
			};
			$[5] = isStacked;
			$[6] = size;
			$[7] = spacing;
			$[8] = t5$1;
		} else t5$1 = $[8];
		t4 = validChildren.reverse().map(t5$1);
		$[0] = children;
		$[1] = isStacked;
		$[2] = size;
		$[3] = spacing;
		$[4] = t4;
	} else t4 = $[4];
	const clones = t4;
	let t5;
	if ($[9] !== clones) {
		t5 = /* @__PURE__ */ jsx(Flex, {
			direction: "row-reverse",
			justifyContent: "start",
			gap: 0,
			children: clones
		});
		$[9] = clones;
		$[10] = t5;
	} else t5 = $[10];
	return t5;
};

//#endregion
export { Avatar, AvatarBadge, AvatarGroup };
//# sourceMappingURL=Avatar.js.map